var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ig-page-base',{staticClass:"page-terms",attrs:{"is-boxed":true,"type":"large"}},[_c('vue-pdf-embed',{attrs:{"source":"https://assets.integrai.com.br/contrato_termos_e_condicoes_de_uso.pdf"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }